import { defineStore } from 'pinia'
import { startsWith } from 'lodash'
import { api } from '@/services'

export const useProfileImagesStore = defineStore('profile-images', {
    state: () => {
        return {
            imageUrlsByApiUrl: {},
        }
    },
    actions: {
        async clearCache(url) {
            delete this.imageUrlsByApiUrl[url]
        },
        // If the image is from our API, we need to make requests to find out the actual image URL
        // We assume that in this situation the image will be provided as an image URL data object
        async resolvePotentialApiImageUrl(url, useCache = true) {
            const isApiUrl = startsWith(url, api.defaults.baseURL)
            if (!isApiUrl) {
                return url
            }

            if (useCache && this.imageUrlsByApiUrl[url]) {
                return this.imageUrlsByApiUrl[url]
            }

            return api.get(url)
                .then(({ data }) => {
                    this.imageUrlsByApiUrl[url] = data.url
                    return data.url
                })
        },
    },
})
